import React, {useContext, useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, Grid} from "@mui/material";
import {blueColor} from "../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import MyPickingMission from "./components/MyPickingMission";
import MobileItem from "../MobileItem";
import Badge from "../../../Badge";
import {getTasks} from "../../../../api/wms/tasks/list";
import {WMSContext} from "../../../../views/wms/context/WMSContext";
import {ReactComponent as ArrowRightIcon} from "assets/img/wms/arrow-right.svg";
import BeatLoaderRegular from "../../../loaders/BeatLoaderRegular";
import MonoMultiSubtitle from "./components/MonoMultiSubtitle";

MyTask.propTypes = {
    passedTask: PropTypes.array,
};

function MyTask({passedTask = null}) {
    const {currentMember, currentInventory} = useContext(WMSContext)
    const [tasks, setTasks] = useState(passedTask || [])
    const [open, setOpen] = useState(false)
    const [selectedTask, setSelectedTask] = useState({task: null, missionIndex: null})
    const [loading, setLoading] = useState(false);

    const openDrawer = (task, missionIndex) => {
        setSelectedTask({task: task, missionIndex: missionIndex})
        setOpen(true);

    }
    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        if (currentInventory !== null && passedTask === null) {
            setLoading(true);

            getTasks(currentInventory, currentMember.id).then((response) => {
                setTasks(response);
            }).finally(() => {
                setLoading(false);
            })
        }
    }, [currentInventory]);

    useEffect(() => {
        if (passedTask) {
            setTasks(passedTask)
        } else {
            setTasks([])
        }
    }, [passedTask]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '16px'
            }}>
                <BeatLoaderRegular loading={true} />
            </div>
        )
    }

    if (tasks.length === 0) {
        return null
    }

    return (
        <>
            {/* Drawer */}
            <MyPickingMission
                task={selectedTask.task}
                open={open}
                handleClose={handleClose}
                missionIndex={selectedTask.missionIndex}
            />
            <Card sx={{
                marginBottom: '32px',
                boxShadow: 0,
                padding: '0 0',
            }}>
                <CardContent sx={{paddingX: 0}}>
                    <div style={{
                        color: blueColor,
                        fontSize: '16px',
                        fontWeight: 600,
                        marginBottom: '32px',
                        marginLeft: '16px'
                    }}>
                        <FormattedMessage id={"wms.myPickingMissions.title"}/>
                    </div>

                    <Grid
                        container
                        direction={'column'}
                    >
                        {tasks.map((task, index) => {
                            let countUniquePlaces = task.uniqueWMSItemsPlaces.length
                            let placeDisplay = ""

                            if (countUniquePlaces > 1) {
                                placeDisplay = <>{countUniquePlaces} <FormattedMessage
                                    id={"wms.myPickingMission.zones"}/></>
                            } else if (countUniquePlaces === 1) {
                                placeDisplay = task.uniqueWMSItemsPlaces[0].name
                            } else {
                                placeDisplay = <FormattedMessage id={"wms.myPickingMission.noZone"}/>
                            }
                            return (
                                <Grid
                                    item
                                    key={task.id}
                                >
                                    <div onClick={() => openDrawer(task, index + 1)}>
                                        <MobileItem>
                                            <MobileItem.LeftSide
                                                title={task.name}
                                                subtitle={
                                                    <>
                                                        <MonoMultiSubtitle task={task} />
                                                        &nbsp;·&nbsp;{task.wmsItems.length}
                                                        &nbsp;<FormattedMessage id={"wms.myPickingMission.articles"} />
                                                    </>
                                                }
                                            />
                                            <MobileItem.RightSide>
                                                <Grid
                                                    container
                                                    direction={'row'}
                                                    alignItems={'center'}
                                                >
                                                    <Grid
                                                        sx={{marginRight: '16px'}}
                                                    >
                                                        <Badge
                                                            rounded
                                                            isBold={false}
                                                        >
                                                            {placeDisplay}
                                                        </Badge>
                                                    </Grid>
                                                    <ArrowRightIcon/>
                                                </Grid>
                                            </MobileItem.RightSide>
                                        </MobileItem>
                                    </div>
                                </Grid>
                            )
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default MyTask;
